import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/pages/HomePage.vue";
import BackNumber from "@/pages/BackNumberPage.vue";
import NewsDetail from "@/pages/NewsDetailPage.vue";
import SalesTalk from "@/pages/SalesTalkPage.vue";
import UsageAgreement from "@/pages/UsageAgreement.vue";
import Error403 from "@/pages/403Error.vue";

const API_URL = process.env.VUE_APP_API_URL;

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
    meta: { title: 'SFPP Top' },
    beforeEnter: (to, from, next) => {
      const referrer = document.referrer;
      // 本番環境の場合のみSFPP TOPにsmarts-Rのリファラチェックを実行
      if (API_URL === "https://sfpp.smarts-r.jp") {
        if (referrer && referrer.includes("https://mkicl.outsystemsenterprise.com")) {
          next();
        } else {
          next("/403");
        }
      } else {
        next();
      }
    },
  },
  {
    path: "/backNumber",
    name: "BackNumber",
    component: BackNumber,
    meta: { title: 'ニュースのバックナンバー' },
  },
  {
    path: "/news/:article_id",
    name: "NewsDetail",
    component: NewsDetail,
    meta: { title: 'ニュース詳細 ' },
    props: true,
  },
  {
    path: "/sales-talk/:article_id",
    name: "SalesTalk",
    component: SalesTalk,
    meta: { title: '営業トーク例生成' },
    props: true,
  },
  {
    path: "/usage-agreement/:article_id",
    name: "UsageAgreement",
    component: UsageAgreement,
    meta: { title: 'AI使用同意確認' },
    props: true,
  },
  {
    path: "/403",
    name: "Error403",
    meta: { title: '403 エラーページ' },
    component: Error403,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

  // ローカル開発環境ではコメントアウトすること
  // SFPP TOPと403エラーページではチェック除外
  router.beforeEach((to, from, next) => {
    if (to.name === "HomePage" || to.path === "/403") {
      next();
      return;
    }

    const referrer = document.referrer;
    // リファラが空であれば直接アクセスと判断し403ページへリダイレクト
    if (!referrer) {
      next("/403");
      return;
    }

    // SFPP TOPと403エラーページ以外は、API_URLを含むURLからの遷移であることをチェック
    if (referrer.includes(API_URL)) {
      next(); // 許可
    } else {
      next("/403");
    }
  });

  // 各ページから次ページへの遷移前に行う処理を設定する
  router.beforeEach((to, from, next) => {
    // ページ名称の設定
    document.title = to.meta.title || 'デフォルトタイトル';
    // ページ遷移する
    next();
  });

  router.afterEach((to) => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_title: document.title,
      });
    }
  });

export default router;
